var map = {
	"./about/About": 32,
	"./about/About.js": 32,
	"./about/core_values/CoreValues": 8,
	"./about/core_values/CoreValues.js": 8,
	"./about/core_values/CoreValues.scss": 35,
	"./about/founder/Founder": 6,
	"./about/founder/Founder.js": 6,
	"./about/founder/Founder.scss": 33,
	"./about/member/Member": 36,
	"./about/member/Member.js": 36,
	"./about/member/member": 24,
	"./about/member/member.scss": 24,
	"./about/vision/Vision": 7,
	"./about/vision/Vision.js": 7,
	"./about/vision/Vision.scss": 34,
	"./admin_tasks/AdminTasks": 25,
	"./admin_tasks/AdminTasks.js": 25,
	"./admin_tasks/AdminTasks.scss": 37,
	"./educators/Educators": 26,
	"./educators/Educators.js": 26,
	"./educators/Educators.scss": 38,
	"./footer/Footer": 31,
	"./footer/Footer.js": 31,
	"./footer/Footer.scss": 39,
	"./header/Header": 27,
	"./header/Header.js": 27,
	"./header/Header.scss": 42,
	"./header/desktopHeader/DesktopHeader": 9,
	"./header/desktopHeader/DesktopHeader.js": 9,
	"./header/desktopHeader/DesktopHeader.scss": 40,
	"./header/mobileHeader/MobileHeader": 10,
	"./header/mobileHeader/MobileHeader.js": 10,
	"./header/mobileHeader/MobileHeader.scss": 41,
	"./home/Home": 43,
	"./home/Home.js": 43,
	"./home/icon_section/IconSection": 28,
	"./home/icon_section/IconSection.js": 28,
	"./home/icon_section/IconSection.scss": 47,
	"./home/intro/Intro": 13,
	"./home/intro/Intro.js": 13,
	"./home/intro/Intro.scss": 46,
	"./home/privacy_popup/PrivacyPopup": 12,
	"./home/privacy_popup/PrivacyPopup.js": 12,
	"./home/privacy_popup/PrivacyPopup.scss": 45,
	"./home/services/Services": 11,
	"./home/services/Services.js": 11,
	"./home/services/Services.scss": 44,
	"./news/News": 29,
	"./news/News.js": 29,
	"./news/News.scss": 65,
	"./news/intro/Intro": 14,
	"./news/intro/Intro.js": 14,
	"./news/intro/Intro.scss": 48,
	"./news/list/List": 15,
	"./news/list/List.js": 15,
	"./news/list/List.scss": 52,
	"./news/newsletter_popup/NewsletterPopup": 16,
	"./news/newsletter_popup/NewsletterPopup.js": 16,
	"./news/newsletter_popup/NewsletterPopup.scss": 64,
	"./news/post_actions/PostActions": 3,
	"./news/post_actions/PostActions.js": 3,
	"./news/post_actions/PostActions.scss": 51,
	"./news/post_card/PostCard": 4,
	"./news/post_card/PostCard.js": 4,
	"./news/post_card/PostCard.scss": 49,
	"./news/subscription_form/SubscriptionFields": 17,
	"./news/subscription_form/SubscriptionFields.js": 17,
	"./news/subscription_form/SubscriptionFields.scss": 53,
	"./tutoring_programs/TutoringPrograms": 66,
	"./tutoring_programs/TutoringPrograms.js": 66,
	"./tutoring_programs/approach/Approach": 19,
	"./tutoring_programs/approach/Approach.js": 19,
	"./tutoring_programs/approach/Approach.scss": 68,
	"./tutoring_programs/infographic/Infographic": 20,
	"./tutoring_programs/infographic/Infographic.js": 20,
	"./tutoring_programs/infographic/Infographic.scss": 69,
	"./tutoring_programs/intro/Intro": 18,
	"./tutoring_programs/intro/Intro.js": 18,
	"./tutoring_programs/intro/Intro.scss": 67
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 96;